import { getEnv } from '@hub/helpers/getters.store';

export class PaymentSessionStore {
  async getPaymentSession(sessionId: string) {
    try {
      const {
        apiFactory: { paymentSessionService },
      } = getEnv();

      return paymentSessionService.getPaymentSession(sessionId);
    } catch (e) {
      console.error(`Failed getting payment session ${sessionId}`, e);

      throw e;
    }
  }

  async confirmPaymentHandleToken(
    paymentHandleToken: string,
    sessionId: string,
  ) {
    try {
      const {
        apiFactory: { paymentSessionService },
      } = getEnv();

      return paymentSessionService.confirmPaymentHandleToken(
        paymentHandleToken,
        sessionId,
      );
    } catch (e) {
      console.error(
        `Failed confirming payment handle token ${paymentHandleToken} for session ${sessionId}`,
        e,
      );

      throw e;
    }
  }

  async claimPaymentSession(sessionId: string) {
    try {
      const {
        apiFactory: { paymentSessionService },
      } = getEnv();

      return paymentSessionService.claimPaymentSession(sessionId);
    } catch (e) {
      console.error(`Failed claiming payment session ${sessionId}`, e);
      throw e;
    }
  }
}
